function mergeRefs(refs) {
  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        // @ts-ignore
        ref.current = node;
      }
    });
  };
}

export default mergeRefs;
//# sourceMappingURL=mergeRefs.js.map
